import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Fasting } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import SyncableModel from "../../database/SyncableModel";
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import JalaAnalytic from "../../utils/jala-analytic"

const FastingStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const FastingStoreModel = types
  .model("FastingStore")
  .props(FastingStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FastingStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(Fasting, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - added', data)
          return success;
        });
    },
    async storeOffline(data) {
      return self.storeModelOffline(Fasting, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - added', data)
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(Fasting, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - edited', data)
          return success;
        });
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(Fasting, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - edited', data)
          return success;
        });
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(Fasting, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - delete', model.toArray())
          return success;
        });
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(Fasting, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: fasting - delete', model.toArray())
          return success;
        });
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type FastingStoreType = Instance<typeof FastingStoreModel>
export interface FastingStore extends FastingStoreType {}
type FastingStoreSnapshotType = SnapshotOut<typeof FastingStoreModel>
export interface FastingStoreSnapshot extends FastingStoreSnapshotType {}
export const createFastingStoreDefaultModel = () => types.optional(FastingStoreModel, {})
